import { useOutlet } from "react-router-dom";

function UiKitLayout({ children }) {
  const outlet = useOutlet();
  return !outlet ? children : outlet;
}

export default UiKitLayout;
